import React, { useEffect, useState } from "react"
import styles from "./Checkbox.module.scss"
interface CheckboxOption {
    title: string
    id: number
}

interface CustomCheckboxProps {
    name?: string
    options: CheckboxOption[]
    onChange: (selectedValues: CheckboxOption[]) => void
    initialValues: CheckboxOption[]
    disabled?: boolean
    highlightChecked?: boolean
}

const CheckboxList: React.FC<CustomCheckboxProps> = ({
    name = "",
    options,
    onChange,
    initialValues,
    disabled = false,
    highlightChecked = false,
}) => {
    const [selectedValues, setSelectedValues] = useState<CheckboxOption[]>(initialValues)

    const isChecked = (id: number | string) => {
        return initialValues?.length
            ? initialValues.some((v: CheckboxOption) => v.id === id)
            : selectedValues.some((v: CheckboxOption) => v.id === id)
    }

    const toggleCheckbox = (option: CheckboxOption) => {
        const isSelected = isChecked(option.id)

        const newSelectedValues = isSelected
            ? selectedValues?.length
                ? selectedValues.filter((v: CheckboxOption) => v.id !== option.id)
                : initialValues.filter((v: CheckboxOption) => v.id !== option.id)
            : [...initialValues, option]
        setSelectedValues(newSelectedValues)
        onChange(newSelectedValues)
    }

    useEffect(() => {
        setSelectedValues(initialValues)
    }, [initialValues])

    return (
        <div style={{ display: "flex" }}>
            {options.map(option => (
                <label
                    key={option.id}
                    className={`d-flex align-items-center mr-37 text-13 ${highlightChecked ? (isChecked(option.id) ? "weight-500" : "") : ""}`}
                >
                    <input
                        name={name}
                        type="checkbox"
                        value={option.id}
                        className={`${highlightChecked ? (isChecked(option.id) ? styles.highlightChecked : "") : ""} mr-3 mb-3`}
                        checked={isChecked(option.id)}
                        onChange={() => toggleCheckbox(option)}
                        disabled={disabled}
                    />
                    {option.title}
                </label>
            ))}
        </div>
    )
}

export default CheckboxList
